import moment from "moment";
import { formatTime } from '../../../helpers/formatting';

export function formattingTime(time) {
  return formatTime(time);
};


export function checkIn(checkInStart, checkInEnd) {
  let checkIn;
    if(checkInStart === "Flexible") {
    checkIn = "Flexible";
  } else {
      if(checkInEnd === "Flexible"){
      checkIn = "From " + formattingTime(checkInStart);
    } else {
        if(checkInStart != null && checkInEnd != null ) {
        checkIn = formattingTime(checkInStart) + " - " + formattingTime(checkInEnd);
      }
    }
  }

  return checkIn;
};

export function checkValue(value, defaultValue) {
  return value !== null ? value : defaultValue;
};

export async function utcTimeFormat(blockedDates) {

  return new Date(moment.utc(new Date(blockedDates)).format('l LT'));

};
